import { j as e } from "./jsx-runtime.js";
import { c as n } from "./emotion-css.esm.js";
import { p as _ } from "./index2.js";
import { C as M } from "./index3.js";
import { M as T, I, J as B, Z as N, d as P } from "./ui-text.js";
import { useState as k } from "react";
import { useChatbotContext as F } from "./useChatbotContext.js";
import { c as R } from "./index6.js";
import { PoweredByAtlasVectorSearch as A } from "./PoweredByAtlasVectorSearch.js";
import "./index4.js";
import "./util.js";
import "./index5.js";
import "./polished.esm.js";
import "./index8.js";
import "react-dom";
import "./index9.js";
import "./ChatbotProvider.js";
import "./useLinkData.js";
import "./LinkDataProvider.js";
import "./utils.js";
const s = {
  info_box: n`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-left: 8px;
  `,
  chatbot_container: n`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    & * {
      box-sizing: border-box;
    }
  }`,
  chatbot_input: n`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  `,
  powered_by_footer: n`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-right: 24px;
  `
};
function re(i) {
  const { darkMode: m } = _(i.darkMode), {
    className: f,
    suggestedPrompts: r = [],
    bottomContent: x,
    fatalErrorMessage: h = P
  } = i, {
    openChat: c,
    awaitingReply: u,
    handleSubmit: p,
    conversation: o,
    inputText: l,
    setInputText: g,
    inputTextError: a,
    isExperimental: b
  } = F(), [v, d] = k(!1), w = a.length === 0 && !o.error, y = a !== "", j = a !== "" && !open, C = r.length > 0 && l.length === 0 && o.messages.length === 0 && !u, E = v || l.length > 0 ? void 0 : b ? "Experimental" : void 0, S = o.error ? h : i.placeholder ?? T();
  return /* @__PURE__ */ e.jsx("div", { className: R(s.chatbot_container, f), children: /* @__PURE__ */ e.jsxs("div", { className: s.chatbot_input, children: [
    /* @__PURE__ */ e.jsx(
      I,
      {
        darkMode: m,
        hasError: y ?? !1,
        badgeText: E,
        dropdownProps: {
          usePortal: !1
        },
        dropdownFooterSlot: /* @__PURE__ */ e.jsx("div", { className: s.powered_by_footer, children: /* @__PURE__ */ e.jsx(A, {}) }),
        textareaProps: {
          value: l,
          onChange: (t) => {
            g(t.target.value);
          },
          placeholder: S
        },
        onMessageSend: async (t) => {
          if (o.messages.length > 0) {
            c();
            return;
          }
          w && await p(t);
        },
        onClick: async () => {
          o.messages.length > 0 && c(), o.conversationId || await o.createConversation();
        },
        onFocus: () => {
          d(!0);
        },
        onBlur: () => {
          d(!1);
        },
        children: C ? /* @__PURE__ */ e.jsx(B, { label: "SUGGESTED AI PROMPTS", children: (r == null ? void 0 : r.map((t) => /* @__PURE__ */ e.jsx(
          N,
          {
            onClick: async () => {
              await p(t);
            },
            children: t
          },
          t
        ))) ?? null }) : void 0
      },
      "inputBarTrigger"
    ),
    /* @__PURE__ */ e.jsxs("div", { className: s.info_box, children: [
      j ? /* @__PURE__ */ e.jsx(M, { children: a }) : null,
      x
    ] })
  ] }) });
}
export {
  re as InputBarTrigger
};
